__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "reactroot-legacy";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e("vendor-_yarn___virtual___react-dom-virtual-05f150c4a1_0_cache_react-dom-npm-18_2_0-dd675bca1c-bb92ad"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_7bcb")]).then(() => (() => (__webpack_require__(75304))))));
			register("react-i18next", "15.6.0", () => (Promise.all([__webpack_require__.e("vendor-_yarn___virtual___react-i18next-virtual-1cf0d541b0_0_cache_react-i18next-npm-15_6_0-59-c9342f"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_fdf4")]).then(() => (() => (__webpack_require__(8159))))));
			register("react-i18next", "15.6.0", () => (Promise.all([__webpack_require__.e("vendor-_yarn___virtual___react-i18next-virtual-8882da3696_0_cache_react-i18next-npm-15_6_0-59-08fbf8"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_fdf4")]).then(() => (() => (__webpack_require__(52837))))));
			register("react", "18.2.0", () => (__webpack_require__.e("react-_yarn_cache_react-npm-18_2_0-1eae08fee2-b9214a9bd7_zip_node_modules_react_index_js").then(() => (() => (__webpack_require__(83249))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};